import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { useRewampLocalization, useRewampT } from "../localisation";

// "Can't remember your DBT ID? Recover" / "Don't have a DBT ID? Register Now" — shared by the
// registration card (inside it) and the identity gate (below its card).
export default function RewampDbtHelperLinks({ onRecover, onRegister, rowGap = 1.5, sx = null }) {
  useRewampLocalization(["farmerVerify"]);
  const t = useRewampT();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: rowGap, ...sx }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Typography variant="body2" sx={{ color: "neutral.body" }}>
          {t("DBT_HELPER.CANT_REMEMBER")}
        </Typography>
        <Button variant="link" onClick={onRecover} disabled={!onRecover}>
          {t("DBT_HELPER.RECOVER")}
        </Button>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Typography variant="body2" sx={{ color: "neutral.body" }}>
          {t("DBT_HELPER.DONT_HAVE")}
        </Typography>
        <Button variant="link" onClick={onRegister}>
          {t("DBT_HELPER.REGISTER_NOW")}
        </Button>
      </Box>
    </Box>
  );
}

RewampDbtHelperLinks.propTypes = {
  onRecover: PropTypes.func,
  onRegister: PropTypes.func.isRequired,
  rowGap: PropTypes.number,
  sx: PropTypes.object,
};
